var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3235 18.5033L19.0008 15.193C19.6049 13.9893 20.0077 12.5849 20.0077 11.1806C20.0077 6.4659 16.1815 2.65405 11.4491 2.65405C6.71679 2.65405 2.89062 6.4659 2.89062 11.1806C2.89062 15.8952 6.71679 19.7071 11.4491 19.7071C12.8588 19.7071 14.2684 19.3058 15.4767 18.7039L18.7994 22.0142C19.8063 23.0174 21.3166 23.0174 22.3235 22.0142C23.2297 21.0111 23.2297 19.5064 22.3235 18.5033ZM11.4491 17.7008C7.82436 17.7008 4.90439 14.7918 4.90439 11.1806C4.90439 7.56933 7.82436 4.66029 11.4491 4.66029C15.0739 4.66029 17.9939 7.56933 17.9939 11.1806C17.9939 14.7918 15.0739 17.7008 11.4491 17.7008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0a6621a1.svg";
export { ForwardRef as ReactComponent };